import { render, staticRenderFns } from "./WebsiteMessagesList.vue?vue&type=template&id=35fa6a8e&scoped=true&"
import script from "./WebsiteMessagesList.vue?vue&type=script&lang=js&"
export * from "./WebsiteMessagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa6a8e",
  null
  
)

export default component.exports